import { BANNER_1, BANNER_2, BANNER_3, BANNER_4 } from './images';

export const BANNERS = [BANNER_1, BANNER_2, BANNER_3, BANNER_4];
